import { render } from "./BasicTextArea.vue?vue&type=template&id=2c66dbc6"
import script from "./BasicTextArea.vue?vue&type=script&lang=js"
export * from "./BasicTextArea.vue?vue&type=script&lang=js"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__